import ContentfulClient from '../utils/ContentfulClient';
import Settings from '../constants/Settings';
import LanguageTools from '../utils/LanguageTools';

/**
 * It's possible to sync all content from contentful into
 * and then return delta updates
**/
/**
ContentfulClient.sync({
  initial: true,
  resolveLinks: true
})
.then((response) => {
  console.log("Contentful client sync")
  console.log(response.entries)
  console.log(response.assets)
})
**/

const API = {};

//////////////////
//// Helpers ////
////////////////
API.calcLanguage = function(i18n){
  // Allow language override via URL query param (e.g. ?lang=en-GB) for one offs e.g. showing terms in different languages
  const searchParams = new URLSearchParams(window.location.search);
  const langOverride = searchParams.get("lang");
  if (langOverride){
    return langOverride;
  }

  if (!i18n.hasOwnProperty("language") || i18n.language === undefined){
    return 'en-GB';
  }
  if (i18n.language.toLowerCase() === 'eu' ){
    return 'en-EU';
  } else {
    // Ignore case on language code and return correctly fomratted for contentful
    switch(i18n.language.toLowerCase()){
      case "en-uk":
        return "en-GB";
      case "en-gb":
        return "en-GB";
      case "en-us":
        return "en-US";
      case "de-de":
        return "de-DE";
      case "fr-fr":
        return "fr-FR";
      case "it-it":
        return "it-IT";
      case "nl-nl":
        return "nl-NL";
      case "de-at":
        return "de-AT";
      case "fr-be":
        return "fr-BE";
      case "nl-be":
        return "nl-BE";
      case "pt-pt":
        return "pt-PT";
      case "es-es":
        return "es-ES";
    }
    return i18n.language;
  }
}

API.inlineContent = function(content){
  // Move contentful content links and images inline
  content.items.forEach( (item, index) => {
    content.items[index].fields = API.inlineFields(item.fields, content.includes)
  })
  return content;
}

///////////////////////////
//// NEWSLETTER / API ////
/////////////////////////
API.submitNewsletter = function (data) {
  var newsletterURL = Settings.ENDPOINT_NEWSLETTER
  return fetch(newsletterURL, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(data)
  })
}

///////////////////////
//// VOTING / API ////
/////////////////////
API.submitVotes = function (data) {
  const voteURL = Settings.ENDPOINT_VOTE
  return fetch(voteURL, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(data)
  })
}

/////////////////////////
//// VOTING / dates ////
///////////////////////
API.getVotingPeriod = function () {
  var voteURL = Settings.ENDPOINT_PERIOD
  return fetch(voteURL, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
  })
}

///////////////////////////
////  SweepStake Info ////
/////////////////////////
API.getSweepstakesInfo = function () {
  var sweepstakesURL = Settings.ENDPOINT_SWEEPSTAKES
  const f = fetch(sweepstakesURL, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
  })
  return f;
}

//////////////////
//// Content ////
////////////////

API.getLocales = function(){
  //alert("getLocales: api");
  return ContentfulClient.getLocales()
}

// Dictionary Items
API.getDictionary = function (language) {
  return ContentfulClient.getEntries({
    content_type: 'dictionary',
    //include: 1,
    locale: LanguageTools.formatLocaleForContentful(language),
    limit: 1000,
  })
}

// Settings Items
API.getSettings = function (i18n) {
  return ContentfulClient.getEntries({
    content_type: 'setting',
    locale: LanguageTools.formatLocaleForContentful(API.calcLanguage(i18n)),
    limit: 100,
  })
}

// Pages
API.getPages = function (i18n) {
  return ContentfulClient.getEntries({
    content_type: 'page',
    include: 1,
    locale: LanguageTools.formatLocaleForContentful(API.calcLanguage(i18n)),
  })
}

// Fetch Single Dictionary Item
// Get all locale versions of entry
API.getDictionaryAllLocales = function (key) {
  return ContentfulClient.getEntries({
    'fields.key.en-GB': key,
    content_type: 'dictionary',
    include: 1, // Max depth
    locale: '*', // Get all locales for this entry
  })
}

// Fetch single page using getEntries (to include assets and includes)
API.getPageNew = function (i18n, id) {
  return ContentfulClient.getEntries({
    'sys.id' : id,
    content_type: 'page',
    include: 10,
    locale: LanguageTools.formatLocaleForContentful(API.calcLanguage(i18n)),
  })
}

API.getPage = function (i18n, id) {
  return ContentfulClient.getEntry(id, {
    include: 10, // Max depth
    locale: LanguageTools.formatLocaleForContentful(API.calcLanguage(i18n)),
  })
}

API.getPageBySlug = function (i18n, slug) {
  return ContentfulClient.getEntries({
    content_type: 'composePage',
    //select: 'fields',
    'fields.slug': slug,
    include: 10, // Max depth
    locale: LanguageTools.formatLocaleForContentful(API.calcLanguage(i18n)),
  })
}

// Categories
API.getCategories = function (i18n) {
  return ContentfulClient.getEntries({
    content_type: 'category',
    include: 10,
    locale: LanguageTools.formatLocaleForContentful(API.calcLanguage(i18n)),
  })
}

// Judges
API.getJudges = function (i18n) {
  return ContentfulClient.getEntries({
    content_type: 'judge',
    include: 10,
    locale: LanguageTools.formatLocaleForContentful(API.calcLanguage(i18n)),
  })
}

export default API;
